import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestHierarchyPut = {
    path: "/hierarchy/:id",
    method: RouteHttpVerb.PUT
};
export { locationRestHierarchyPut };
